import { Assignment } from '@models/performance/assignment.model';
import { ReviewResponse } from '@models/performance/review-response.model';

export class ReviewAssignment extends Assignment {
    get response(): ReviewResponse {
        return this.hasOne(ReviewResponse, 'response');
    }
}
